const routes = [
    {
        path: 'solicitacoes',
        name: 'Licitacoes_Solicitacoes',
        component: () => import('./listagem/Listagem.vue'),
        meta: {
            keepAlive: true,
        },
    },
    {
        path: 'solicitacoes/inserir',
        name: 'Licitacoes_Solicitacoes_Inserir',
        component: () => import('./inserir/Inserir.vue'),
    },
    {
        path: 'solicitacoes/:id',
        name: 'Licitacoes_Solicitacoes_Detalhar',
        component: () => import('./detalhamento/Detalhar.vue'),
    },
    {
        path: 'solicitacoes/classificar/:id',
        name: 'Licitacoes_Solicitacoes_Classificar',
        component: () => import('./detalhamento/Classificacao/Classificacao.vue'),
    },
    {
        path: 'solicitacoes/:id',
        name: 'Licitacoes_Solicitacoes_Aprovar_Tr',
        component: () => import('./statusFases/AprovarTr.vue'),
    },
    {
        path: 'solicitacoes/:id',
        name: 'Licitacoes_Solicitacoes_Publicar_Edital',
        component: () => import('./statusFases/PublicarEditalForm.vue'),
    },
    {
        path: 'solicitacoes/:id',
        name: 'Licitacao_Elaborar_Edital',
        component: () => import('./detalhamento/ElaboracaoEdital/ElaborarEditalLicitacao.vue'),
    },
];

export default routes;
